import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=c26fb2bc&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=ts"
export * from "./Statistics.vue?vue&type=script&lang=ts"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=c26fb2bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26fb2bc",
  null
  
)

export default component.exports